/* eslint-disable no-console */

if ('serviceWorker' in navigator) {
  let sw = process.env.NODE_ENV === 'production' ? 'service-worker.js' : 'service-worker-dev.js';
  let scope = process.env.BASE_URL;
  
  navigator.serviceWorker.register(process.env.BASE_URL + sw, { scope: scope}).then((registration) => {
    console.log('Registrou service worker');
  });
}